import React from 'react';
import { theme } from '../../config/theme';

const Avatar = ({ 
  src, 
  alt = '', 
  name = '',
  size = 'md',
  className = '' 
}) => {
  const sizes = {
    sm: '32px',
    md: '40px',
    lg: '48px',
    xl: '64px',
  };

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const avatarStyles = {
    width: sizes[size],
    height: sizes[size],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: size === 'sm' ? theme.typography.fontSize.xs : theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.semibold,
    backgroundColor: theme.colors.primary.main,
    color: theme.colors.white,
    overflow: 'hidden',
  };

  return (
    <div className={className} style={avatarStyles}>
      {src ? (
        <img 
          src={src} 
          alt={alt || name} 
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <span>{getInitials(name)}</span>
      )}
    </div>
  );
};

export default Avatar;